
<template>
  <div id="absenteeism">
    <div class="p-2">
      <div class="d-flex align-items-center justify-content-start">
        <img class="centerImg1 mr-3" src="@/assets/images/icons/event_seat_2.svg" width="25px">
        <h3 class="title-h3">Ausentismos</h3>
      </div>

      <!-- Bottones de opciones -->
      <div class="mt-5 p-0 col-12 d-flex align-items-center justify-content-between">
        <button v-if="user.core_role_id==17"
                @click="newAbs()"
                class="button-v2 primary new-responsive">
          Agregar nuevo ausentismo
          <span>
                        <img class="centerImg1 ml-2" src="@/assets/images/icons/icon_more.svg" width="20px" />
                    </span>
        </button>

        <button class="button-v2 outline-primary regular text-right"
                @click="getHistoryAbs(dataUser.id)">
          Ver historial de ediciones
          <span>
                        <img class="centerImg1 ml-2" src="@/assets/images/icons/ht_icon_modification.svg" width="20px">
                    </span>
        </button>

        <button
            v-if="filterButton"
            id="popover-reactive-1"
            ref="button"
            class="button-v2 outline-primary border-round"
            @click="filter">
          <div class="m-1 d-flex align-items-center justify-content-between">
            <p class="m-0 pr-2">
              Filtro
            </p>
            <img class="centerImg1 arrow" src="@/assets/images/icons/ht_icon_stack.svg" width="15px">
          </div>
        </button>

        <router-link :to="'/detailAbsenteeism/' + dataUser.id" v-if="HistoryButtonAbs"
                     class="button-v2 no-border-primary d-flex align-items-center float-right">
          <div class="textButtonColapse m-3 d-flex align-items-center justify-content-between">
            <p class="m-0 pr-2">Ver historial de ausentismos</p>
            <span>
                            <img class="centerImg1 arrow" src="@/assets/images/icons/ht_icon_history.svg" width="15px" />
                        </span>
          </div>
        </router-link>
      </div>
      <!-- end -->

      <!-- Filtro -->
      <b-popover
          id="popover"
          target="popover-reactive-1"
          triggers="click"
          :show.sync="popoverShow"
          placement="auto"
          container="filterContainer"
          class="p-3"
          ref="popover"
      >
        <b-col
            cols="12"
            v-if="loading2">
          <loader-version2 />
        </b-col>

        <div v-else>
          <p class="my-1 separate pb-2">
            <strong>Fecha de ausentismos</strong>
          </p>

          <div class="row d-flex justify-content-between mt-2">
            <div class="col-12 col-sm-6">
              <p class="my-1">Fecha inicio</p>
              <b-form-datepicker
                  :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                  size="lg"
                  v-model="filterFrom"
                  placeholder="Fecha inicio"
                  locale="es-CO"></b-form-datepicker>
            </div>
            <!-- Selecciona fecha final -->
            <div class="col-12 col-sm-6">
              <p class="my-1">Fecha fin</p>
              <b-form-datepicker
                  :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                  :min="filterFrom"
                  size="lg"
                  v-model="filterTo"
                  placeholder="Fecha fin"
                  locale="es-CO"></b-form-datepicker>
            </div>
          </div>
          <hr>

          <p class="my-3 separate pb-4">
            <strong>Detalle del ausentismo</strong>
          </p>

          <multiselect
              v-model="selectedAbsFilter"
              class="mb-3"
              selectLabel="Seleccionar"
              deselectLabel="Eliminar"
              placeholder="Tipo de Ausentismo"
              label="name"
              track-by="item"
              :options="optionsAbsFilter"
              :multiple="true"
              :taggable="true"
              @tag="addTag"></multiselect>

          <b-form-select
              class="mt-3 mb-3"
              v-model="selectedDiagFilter"
              :options="optionsDiagFilter"></b-form-select>

          <div class="my-4 d-flex justify-content-around">
            <button
                @click="cleanDataFilter"
                class="p-2 button-v2 outline-danger text-left">
              <strong>
                Borrar Filtros
              </strong>
              <img
                  class="centerImg1 ml-2"
                  src="@/assets/images/icons/ht_icon_draft.svg"
                  width="20px">
            </button>
            <button
                @click="setFilter"
                class="p-2 button-v2 primary text-left">
              <strong>
                Aplicar Filtros
              </strong>
              <img
                  class="centerImg1 ml-2"
                  src="@/assets/images/icons/ht_icon_check.svg"
                  width="20px">
            </button>
          </div>
        </div>
      </b-popover>


      <!-- Tabla de ausentismos -->
      <div class="mt-4 p-0 table-responsive datatable">

        <datatable
            :columns="datatableAbs.columns"
            :data="datatableAbs.rows"
            class="col-12 carlos">
          <template scope="{ row, columns }">
            <tr
                @click="clickRow(dataUser.id, row.id)"
                class="pointer">
              <datatable-cell
                  v-for="(column, j) in columns"
                  :key="j"
                  :column="column"
                  :row="row">
              </datatable-cell>
            </tr>
          </template>
        </datatable>
        <div
            v-if="pagination"
            class="col-12 cont-pagination my-5 d-flex justify-content-center">
          <Pagination
              :data="userAbs"
              :limit="10"
              @pagination-change-page="setFilter" />
        </div>
      </div>


      <div v-if="totalAbsenteeism && stadistics === 'resume'" class="d-flex align-items-center mt-5">
        <PieChart
            class="col-2"
            :chartData="chartData"
            :labels="chartLabels"
            :color="stadisticsColors"
        />
        <p style="font-size: 14px" v-if="totalAbsenteeism.total > 0">En el presente año, <b>{{dataUser.employee}}</b> ha presentado un total de <b>{{totalAbsenteeism.total}}</b> ausentismos en que la mayoria son de tipo <b>{{totalAbsenteeism.name}}</b></p>

        <p v-else style="font-size: 14px">En el presente año, <b>{{dataUser.employee}}</b> No ha presentado ausentismos.</p>
      </div>
      <!-- Modal Nuevo ausentismos -->
      <b-modal id="modal-new-abs" hide-footer centered size='lg' no-close-on-backdrop>
        <div class="modal-abs">
          <h1>Registro de Ausentismo</h1>
          <template v-if="loading2">
            <b-col cols="12">
              <loader-version2 />
            </b-col>
          </template>

          <template v-else>
            <b-col>
              <div class=" table-responsive table-views">
                <datatable
                    :columns="datatableEmployeeModal.columns"
                    :data="datatableEmployeeModal.rows"
                    class="col-12"
                >
                  <template slot-scope="{ row, columns }">
                    <tr>
                      <template>
                        <datatable-cell v-for="(column, j) in columns"
                                        :key="j"
                                        :column="column"
                                        :row="row">
                        </datatable-cell>
                      </template>
                    </tr>
                  </template>
                </datatable>
              </div>
              <b-tabs v-model="tabIndex" content-class="mt-5" align="center">
                <b-tab title="Caracterización" active>
                  <div class="col-8 mx-auto d-flex flex-column">
                    <!-- Buscar tipo de aucensia -->
                    <p style="color:red; text-align: center;" v-if="dataErrors.length">
                      <b style="color:red; text-align: center;">Por favor, corrija el(los) siguiente(s) error(es):</b>
                    <ul>
                      <li style="color:red; text-align: center;" v-for="NameError in dataErrors" v-bind:key="NameError">{{ NameError }}</li>
                    </ul>
                    </p>
                    <div class="mt-3"><span>Tipo de ausentismo</span></div>
                    <v-select placeholder="Selecciona tipo de ausentismo" class="mt-4 col-12 p-0" label="name" :options="typesAbsenteeism" v-model="typeAbsence" @search="filterTypesAbs" @input="actGetRiskClassification(),checkTypeOfAbs()">
                      <template slot="no-options">
                        Ningun resultado encontrado...
                      </template>
                    </v-select>
                    <!-- Si es ausencia por incapacidad... clasificación del riesgo o peligro -->
                    <div class="mt-3" v-if="typeAbsence.options && riskDanger">
                      <span>Clasificación del riesgo o peligro</span>
                    </div>
                    <v-select v-if="typeAbsence.options  && riskDanger" placeholder="Selecciona clasificación del riesgo o peligro" class="mt-4 col-12 p-0" label="name" :options="riskClassification" v-model="riskClassificationSelected" @search="filterRiskClassification" @input="actGetGroupsDiagnostics(), disableFirstStep()">
                      <template slot="no-options">
                        Ningun resultado encontrado...
                      </template>
                    </v-select>
                    <!-- Si es ausencia por incapacidad... grupo de diagnosticos -->
                    <div class="mt-3" v-if="typeAbsence.options && diagnosticGroup">
                      <span>Grupo de diagnóstico</span>
                    </div>
                    <v-select v-if="typeAbsence.options && diagnosticGroup" placeholder="Selecciona grupo de diagnóstico" class="mt-4 col-12 p-0" label="code_name" :options="groupsDiagnostics" v-model="groupDiagnostic" @search="filterGroupsDiagnostics" @input="filterDiagnosticsByGroup">
                      <template slot="no-options">
                        Ningun resultado encontrado...
                      </template>
                    </v-select>
                    <!-- Diagnosticos filtrados por grupo -->
                    <div class="mt-3" v-if="diagnosticGroup && groupDiagnostic.id && diagnosticGroup">
                      <span>Diagnóstico</span>
                    </div>
                    <v-select v-if="diagnosticGroup && groupDiagnostic.id" placeholder="Selecciona el diagnóstico" class="mt-4 col-12 p-0" label="code_name" :options="diagnostics" v-model="diagnosticSelected" @search="filterGroupsDiagnostics" @input="disableFirstStep()">
                      <template slot="no-options">
                        Ningun resultado encontrado...
                      </template>
                    </v-select>
                    <div class="mt-3" v-if="emitterAbsence"><span>Emisor de la ausencia</span></div>
                    <b-form-select class="mt-4" v-model="selectedIssuer" :options="optionsIssuer"  v-if="emitterAbsence" @input="disableFirstStep()"></b-form-select>

                    <button :disabled="showNextStep"
                            class="my-5 mx-auto px-4 col-3 btn btn-success" @click="tabIndex = 1">Siguiente</button>

                  </div>
                </b-tab>
                <b-tab :disabled="showNextStep"
                       title="Detalle">
                  <div class="col-8 mx-auto"><p class="mb-4" style="font-size:14px">Fecha inicial del ausentismo</p></div>
                  <div class="col-8 mx-auto d-flex flex-column detail">
                    <!-- Selecciona fecha inicial -->
                    <div class="position-relative">
                      <small class="text-input">Fecha inicial</small>
                      <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          v-model="reportFrom"
                          class="mb-3"
                          locale="es-CO"></b-form-datepicker>
                    </div>
                    <!-- Selecciona fecha final -->
                    <div class="col-8 p-0"><p class="mb-4" style="font-size:14px">Fecha final del ausentismo</p></div>
                    <div class="position-relative">
                      <small class="text-input">Fecha final</small>
                      <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          :min="reportFrom"
                          v-model="reportTo"
                          class="mb-2"
                          locale="es-CO"></b-form-datepicker>
                    </div>
                    <!-- Dias perdidos en el mes -->
                    <div>
                      <p style="font-size:14px" class="m-0 mt-3">Total de días perdidos</p>
                      <input @keyup="getHours"
                             class="mt-4"
                             type="number"
                             v-model="daysAbs"
                             name=""
                             min="1"
                             :max="get_difference_register_absenteeism"
                             placeholder="Días perdidos" autofocus>
                    </div>
                    <!-- Horas perdidas en el mes -->
                    <div>
                      <p style="font-size:14px" class="m-0 mt-3">Total de Horas de ausencia</p>
                      <input class="mt-4"
                             type="number"
                             v-model="hoursAbs"
                             name=""
                             min="8"
                             :max="get_difference_register_absenteeism_hours"
                             placeholder="Horas de ausencia" autofocus>
                    </div>
                    <button :disabled="reportTo == '' || reportFrom == '' || daysAbs == '' || hoursAbs == ''
                                                    || daysAbs > get_difference_register_absenteeism
                                                    || daysAbs < 1
                                                    || hoursAbs > get_difference_register_absenteeism_hours
                                                    || hoursAbs < 1"
                            class="my-5 mx-auto px-4 col-3 btn btn-success" @click="tabIndex = 2">
                      Siguiente
                    </button>

                  </div>
                </b-tab>
                <b-tab title="Descripción" :disabled="reportTo == '' || reportFrom == '' || daysAbs == '' || hoursAbs == ''">
                  <p style="color:red; text-align: center;" v-if="dataErrorsRegister.length">
                      <b style="color:red; text-align: center;">Por favor, corrija el(los) siguiente(s) error(es):</b>
                    <ul>
                      <li style="color:red; text-align: center;" v-for="NameError in dataErrorsRegister" v-bind:key="NameError">{{ NameError }}</li>
                    </ul>
                  </p>
                  <div class="col-8 mx-auto d-flex flex-column detail">
                    <p style="font-size:14px" class="m-0 mt-4">Descripción de la ausencia</p>
                    <textarea v-model="descriptionAbs" type="text" name="" id="" placeholder="Descripción de la ausencia" rows="10" heigth="200px" ></textarea>
                    <p style="font-size:14px" class="m-0 mt-4">Estado del certificado del ausentismo</p>
                    <b-form-select v-if="typeAbsence.options" class="mt-3" v-model="selectedCertificate" :options="optionsCertificate"></b-form-select>
                    <div class="box-input">
                      <div>
                        <p style="font-size:14px" class="m-0 mt-4">Origen de la incapacidad</p>
                         <b-form-select class="mt-4 mb-3" v-model="inabilityOrigin" :options="optionsOrigen"></b-form-select>
                      </div>
                      <div>
                        <p style="font-size:14px" class="m-0">Médico que emite la incapacidad</p>
                        <input class="mt-4 mb-3"
                               type="text"
                               v-model="medicalDisability"
                               name=""
                               placeholder="Escribe el nombre del médico">
                      </div>
                      <div>
                        <p style="font-size:14px" class="m-0">IPS que emite incapacidad</p>
                        <input class="mt-4 mb-3"
                               type="text"
                               v-model="incapacityIps"
                               name=""
                               placeholder="Selecciona el estado del certificado del ausentismo">
                      </div>
                    </div>
                    <div v-if="selectedCertificate != null && selectedCertificate.id == 'pending'" class="box-input">
                    </div>
                    <div v-if="selectedCertificate != null && selectedCertificate.id == 'received'" class="box-input">
                      <p style="font-size:14px" class="m-0 mb-4">Por favor adjunta el certificado del ausentismo</p>
                      <input type="file" class="form-control" v-on:change="onFileChange" >
                    </div>
                    <button class="my-5 mx-auto px-4 col-3 btn btn-success" @click="validateNewAbs()">Guardar</button>
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>
          </template>
        </div>
      </b-modal>

      <!-- 2 MODAL CONFIRMACIÓN CREACIÓN -->
      <b-modal id="modal-confirm" hide-footer centered size='lg' no-close-on-backdrop>
        <div class="modal-abs">
          <div class="col-12 d-flex flex-column align-items-center">
            <img class="centerImg1" src="@/assets/images/icons/warning.svg" width="10%">
            <h3 class="pt-5 font-weight-bold">{{textConfirm}} {{dataUser.employee}}?</h3>
            <div class="px-3 table-responsive table-views">
              <datatable
                  :columns="tableConfirm1.columns"
                  :data="tableConfirm1.rows"
                  class="col-12 mt-2"
              />

              <datatable
                  :columns="tableConfirm2.columns"
                  :data="tableConfirm2.rows"
                  class="col-12 mt-2"
              />

              <datatable
                  :columns="tableConfirm3.columns"
                  :data="tableConfirm3.rows"
                  class="col-12 mt-2"
              />
              <datatable
                  :columns="tableConfirm4.columns"
                  :data="tableConfirm4.rows"
                  class="col-12 mt-2"
              />
              <datatable
                  :columns="tableConfirm5.columns"
                  :data="tableConfirm5.rows"
                  class="col-12 mt-2"
              />
              <div v-if="selectedCertificate" class="d-flex justify-content-between  align-items-center pt-3 border-top">
                <p style="font-size:14px">Estado del certificado del ausentismo</p>
                <div v-if="selectedCertificate.id == 'received'" class="m-3">
                                                <span class="status mt-4" style="background-color:#EDF9F0">
                                                    <img class="centerImg1 mr-3"  src="@/assets/images/icons/check.svg" width="20px">Recibido
                                                </span>
                </div>
                <div v-if="selectedCertificate.id == 'pending'" class="m-3">
                                                <span class="status" style="background-color:#FFF4EC">
                                                    <img class="centerImg1 mr-3"  src="@/assets/images/icons/orange-clock.svg" width="20px">Pendiente
                                                </span>
                </div>
                <div v-if="selectedCertificate.id == 'not-apply'" class="m-3">
                                                <span class="status" style="background-color:#F5F5F5">
                                                    <img class="centerImg1 mr-3"  src="@/assets/images/icons/close_gray.svg" width="20px">No Aplica
                                                </span>
                </div>
              </div>
            </div>
            <div v-if="!editAbsForm">
              <button class="regular mt-3"
                      :disabled="processingSaveAbsenteeism"
                      @click="$bvModal.hide('modal-confirm'), $bvModal.show('modal-new-abs')">
                Seguir Editando
              </button>
              <button
                  class="mt-2 mb-5 col-6 btn btn-success"
                  :disabled="processingSaveAbsenteeism"
                  @click="saveNewAbs()">
                Guardar
              </button>
            </div>
            <div v-else>
              <button class="regular mt-3" @click="$bvModal.hide('modal-confirm'), $bvModal.show('modal-edit-abs')">Seguir Editando</button>
              <button class="mt-2 mb-5 col-6 btn btn-success" @click="SaveEditAbs()">Guardar Cambios</button>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- 3 MODAL PROCESO EXITOSO  -->
      <b-modal id="modal-success" hide-footer centered no-close-on-backdrop>
        <div class="col-12 d-flex flex-column align-items-center">
          <img class="centerImg1" src="@/assets/images/icons/check_circle_green.svg" width="20%">
          <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
          <p class="pt-5">{{ message.message }}</p>
          <button class="mt-5 mb-5 col-6 btn btn-success" @click="$bvModal.hide('modal-success'),refreshData()">Entendido</button>
        </div>
      </b-modal>

      <!-- 4 MODAL PROCESO FALLIDO -->
      <b-modal v-if="error.message" id="modal-fail" hide-footer centered no-close-on-backdrop>
        <div class="col-12 d-flex flex-column align-items-center">
          <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%">
          <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
          <p class="pt-5">{{error.message}}</p>
          <button class="mt-5 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail'),refreshData()">Entendido</button>
        </div>
      </b-modal>

      <!-- Modal edición -->
      <b-modal id="modal-edit-abs"
               hide-footer
               centered
               size='lg'
               no-close-on-backdrop
               body-class="col-12">
        <b-row class="justify-center">
          <b-col cols="12" v-if="loading2">
            <loader-version2 />
          </b-col>
          <b-col cols="12 table-responsive datatable no-box-shadow table-with-borders" v-else>
            <b-col>
              <datatable
                  :columns="datatableEmployeeModal.columns"
                  :data="datatableEmployeeModal.rows" />
            </b-col>


            <b-col v-if="!editAbsForm">
              <!-- Titulo -->
              <h3 class="font-weight-bold mb-5 mt-5 text-left">
                                <span>
                                    <img class="img-background" src="@/assets/images/icons/ht_icon_modification.svg" >
                                </span>
                Detalle del Ausentismo
              </h3>
              <!-- end -->

              <!-- Table de Type, diagnostic and emisor-->
              <datatable
                  :columns="tableConfirm1.columns"
                  :data="tableConfirm1.rows"
                  class="col-12" />
              <!-- end -->
              <br>
              <!-- Tabla  de Clasificación del origen del peligro / Riesgo que generó el ausentismo -->
              <datatable
                  :columns="tableConfirm2.columns"
                  :data="tableConfirm2.rows"
                  class="col-12"
              />
              <!-- end -->
              <br>
              <!-- Tabla de datos fechas y dias -->
              <datatable
                  :columns="tableConfirm3.columns"
                  :data="tableConfirm3.rows"
                  class="col-12"
              />
              <!-- end -->
              <br>
              <datatable
                  :columns="tableConfirm5.columns"
                  :data="tableConfirm5.rows"
                  class="col-12"
              />
              <!-- end -->
              <br>

              <!-- Text area de descripcion -->
              <label for="textarea" class="text-formatting-v2 ">Descripción de la ausencia</label>
              <textarea
                  id="textarea"
                  class="text-area-v2 text-formatting-v2 "
                  v-model="tableDescription"
                  readonly
                  disabled
                  placeholder="Descripción de la ausencia"
                  >
              </textarea>
              <!-- end -->
              <br>
              <!-- Si existe el ausentismo -->
              <b-col v-if="absenteeism"
                     cols="12"
                     sm="8"
                     class="d-flex mt-5 col-with-border-dotted">
                <p class="text-formatting-v2">
                  Estado del certificado del ausentismo:
                </p>
                <div v-if="absenteeism.status == 'received'" class="ml-5">
                  <span class="status mt-4" style="background-color:#EDF9F0">
                      <img class="centerImg1 mr-3"  src="@/assets/images/icons/check.svg" width="20px">Recibido
                  </span>
                </div>
                <div v-if="absenteeism.status == 'pending'" class="ml-5">
                    <span class="status" style="background-color:#FFF4EC">
                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/orange-clock.svg" width="20px">Pendiente
                    </span>
                </div>
                <div v-if="absenteeism.status == 'not-apply'" class="ml-4">
                    <span class="status" style="background-color:#F5F5F5">
                        <img class="centerImg1 mr-3"  src="@/assets/images/icons/close_gray.svg" width="20px">No Aplica
                    </span>
                </div>
              </b-col>
              <!-- end -->

              <!-- Opciones -->
              <b-col
                  cols="12"
                  class="my-5 text-center">
                <button
                    v-if="roleCan(HTRoleList.OH_ANALYST._id)"
                    class="col-4 button-v2 primary mr-4"
                    @click="editAbs()">
                  Editar detalle
                  <b-icon
                      icon="pencil"
                      font-scale="1"
                      class="pointer ml-2">
                  </b-icon>
                </button>
                <button
                    v-else
                    class="col-4 button-v2 primary"
                    @click="$bvModal.hide('modal-edit-abs')">
                  Entendido
                </button>
              </b-col>
              <!-- end -->
            </b-col>

            <div>
              <div v-if="!editAbsForm" class="editFormAbs">
                <!--<div class="col-12 d-flex flex-column align-items-center"> -->
                <!-- <div class=" table-responsive table-views"> -->
                <!-- <div class="t-head">
                    <p class="font-weight-bold my-2">Detalle del Ausentismos</p>
                </div> -->
                <!-- <datatable
                :columns="tableConfirm1.columns"
                :data="tableConfirm1.rows"
                class="col-12 mt-2"
                /> -->

                <!-- <datatable
                :columns="tableConfirm2.columns"
                :data="tableConfirm2.rows"
                class="col-12 mt-2"
                /> -->

                <!-- <datatable
                :columns="tableConfirm3.columns"
                :data="tableConfirm3.rows"
                class="col-12 mt-2"
                /> -->
                <!-- <datatable
                :columns="tableConfirm4.columns"
                :data="tableConfirm4.rows"
                class="col-12 mt-2"
                />-->
                <!-- <div v-if="absenteeism" class="d-flex justify-content-between  align-items-center pt-3 border-top">
                    <p style="font-size:14px">Estado del certificado del ausentismo</p>
                    <div v-if="absenteeism.status == 'received'" class="m-3">
                            <span class="status mt-4" style="background-color:#EDF9F0">
                                <img class="centerImg1 mr-3"  src="@/assets/images/icons/check.svg" width="20px">Recibido
                            </span>
                    </div>
                    <div v-if="absenteeism.status == 'pending'" class="m-3">
                            <span class="status" style="background-color:#FFF4EC">
                                <img class="centerImg1 mr-3"  src="@/assets/images/icons/orange-clock.svg" width="20px">Pendiente
                            </span>
                    </div>
                    <div v-if="absenteeism.status == 'not-apply'" class="m-3">
                            <span class="status" style="background-color:#F5F5F5">
                                <img class="centerImg1 mr-3"  src="@/assets/images/icons/close_gray.svg" width="20px">No Aplica
                            </span>
                    </div>
                </div> -->
                <!-- </div> -->
                <!-- </div> -->
                <!-- <div class="col-12 my-5 text-center">
                    <button v-if="user.core_role_id==17" class="col-4 btn btn-success" @click="editAbs()">
                        <img class="centerImg1 mr-3" src="@/assets/images/icons/layout-edit.svg" width="20px">Editar detalle
                    </button>
                    <button v-else class="col-4 btn btn-success" @click="$bvModal.hide('modal-edit-abs')">
                        Entendido
                    </button>
                </div> -->
              </div>
              <div v-else class="modal-abs">
                <p class="col-12 font-weight-bold my-2 py-3" style="background-color: #F5F5F5;">Detalle del Ausentismo</p>
                <div class="col-12 font-weight-bold my-2 theading d-flex py-3" style="background-color: #EEF2FA;">
                  <p class="col-6 font-weight-bold my-2 text-center">Tipo</p>
                  <p class="col-6 font-weight-bold my-2 text-center">Diagnostico CIE XI</p>
                </div>

                <form enctype="multipart/form-data">
                  <div class="col-12 d-flex py-3">
                    <div class="col-6 my-2 text-center">
                      <!-- Buscar tipo de aucensia -->
                      <v-select :placeholder="absenteeism.type_absenteeism_name" class="col-12 p-0" label="name" :options="typesAbsenteeism" v-model="typeAbsence" @search="filterTypesAbs" @input="actGetRiskClassification(),checkTypeOfAbs()">
                        <template slot="no-options">
                          Ningun resultado encontrado...
                        </template>
                      </v-select>
                    </div>
                    <div class="col-6 my-2 text-center">
                      <!-- Diagnosticos filtrados por grupo -->
                      <v-select v-if="typeAbsence.options" placeholder="Busca algún diagnostico..." class=" col-12 p-0" label="code_name" :options="diagnostics" v-model="diagnosticSelected" @search="filterDiagnostics">
                        <template slot="no-options">
                          Ningun resultado encontrado...
                        </template>
                      </v-select>
                      <p v-else>No Aplica</p>
                    </div>
                  </div>
                  <div class="col-12 font-weight-bold my-2 theading d-flex py-3" style="background-color: #EEF2FA;">
                    <p class="col-12 font-weight-bold my-2 text-center">Clasificación del origen del peligro o riesgo </p>
                  </div>
                  <div class="col-12 d-flex py-3">
                    <div class="col-12 my-2 text-center">
                      <!-- Si es ausencia por incapacidad... clasificación del riesgo o peligro -->
                      <v-select v-if="typeAbsence.options" placeholder="Busca alguna clasificación del riesgo o peligro..." class="mt-3 col-12 p-0" label="name" :options="riskClassification" v-model="riskClassificationSelected" @search="filterRiskClassification" @input="actGetGroupsDiagnostics()">
                        <template slot="no-options">
                          Ningun resultado encontrado...
                        </template>
                      </v-select>
                      <p v-else>No Aplica</p>
                    </div>
                  </div>
                  <div class="col-12 font-weight-bold my-2 theading d-flex py-3" style="background-color: #EEF2FA;">
                    <p class="col-3 font-weight-bold my-2 text-center">Fecha de Inicio</p>
                    <p class="col-3 font-weight-bold my-2 text-center">Fecha Final</p>
                    <p class="col-2 font-weight-bold my-2 text-center">Días perdidos</p>
                    <p class="col-2 font-weight-bold my-2 text-center">Horas de ausencia</p>
                    <p class="col-2 font-weight-bold my-2 text-center">Emisor</p>
                  </div>
                  <div class="col-12 d-flex py-3">
                    <div class="col-12 font-weight-bold my-2 theading d-flex text-center">
                      <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          v-model="reportFrom"
                          class="mb-3 col-3"
                          locale="es-CO"></b-form-datepicker>
                      <!-- Selecciona fecha final -->
                      <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          :min="reportFrom"
                          v-model="reportTo"
                          class="mb-2 col-3"
                          locale="es-CO"></b-form-datepicker>
                      <input class="mt-3 col-2" type="number" v-model="daysAbs" name="" id="" placeholder="Digite el numero de Dias de ausencia">
                      <!-- Horas perdidas en el mes -->
                      <input class="mt-3 col-2" type="number" v-model="hoursAbs" name="" id="" placeholder="Digite las horas de ausencia perdidos">
                      <!-- emisor -->
                      <b-form-select class="mt-3 col-2" v-model="selectedIssuer" :options="optionsIssuer"></b-form-select>
                    </div>
                  </div>
                  <div class="col-12 font-weight-bold my-2 theading d-flex py-3" style="background-color: #EEF2FA;">
                    <p class="col-12 font-weight-bold my-2 text-center">EMISOR</p>
                  </div>
                  <div class="col-12 font-weight-bold my-2 theading d-flex py-3" style="background-color: #EEF2FA;">
                    <p class="col-3 font-weight-bold my-2 text-center">Origen de la incapacidad</p>
                    <p class="col-3 font-weight-bold my-2 text-center">Médico que emite la incapacidad</p>
                    <p class="col-2 font-weight-bold my-2 text-center">IPS que emite incapacidad</p>
                  </div>
                  <div class="col-12 d-flex py-3">
                    <div class="col-12 font-weight-bold my-2 theading d-flex text-center">
                      <b-form-select class="mt-4 mb-3" v-model="inabilityOrigin" :options="optionsOrigen"></b-form-select>
                      <input class="mt-4 mb-3"
                                type="text"
                                v-model="medicalDisability"
                                name=""
                                placeholder="Escribe el nombre del médico">
                      <input class="mt-4 mb-3"
                                type="text"
                                v-model="incapacityIps"
                                name=""
                                placeholder="Selecciona el estado del certificado del ausentismo">
                    </div>
                  </div>
                  <div class="col-12 font-weight-bold my-2 theading d-flex py-3" style="background-color: #EEF2FA;">
                    <p class="col-12 font-weight-bold my-2 text-center">Descripción</p>
                  </div>
                  <div class="col-12 d-flex py-3">
                    <div class="col-12 my-2 text-center">
                      <!-- Descripción de la ausencia -->
                      <textarea class="col-12" v-model="descriptionAbs" type="text" name="" id="" placeholder="Añade una descripción del ausentismo" rows="10" heigth="200px"></textarea>
                      <b-form-select class="mt-3" v-model="selectedCertificate" :options="optionsCertificate"></b-form-select>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <button class="regular mt-3" @click="viewAbs(absenteeism.id)">Cancelar</button>
                    <button class="mt-2 mb-5 col-4 btn btn-success" @click="confirmNewAbs()">Guardar Cambios</button>
                  </div>
                </form>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-modal>

      <!-- 3 MODAL HISTORIAL CAMBIOS  -->
      <b-modal id="modal-history-abs"
               hide-footer
               centered
               size="lg"
               no-close-on-backdrop>
        <b-container>
          <b-row>
            <b-col md="12" class="pb-3">
              <h3 class="font-weight-bold mb-6 text-left">
                                <span>
                                    <img class="centerImg1 mr-3 img-background" src="@/assets/images/icons/ht_icon_modification.svg" >
                                </span>
                Historial de modificaciones realizadas
              </h3>
            </b-col>
            <b-col cols="12" offset-md="3" v-if="loading2">
              <loader-version2 />
            </b-col>
            <b-col cols="12" class="table-responsive datatable no-box-shadow table-with-borders" v-else>
              <!-- Tabla de historia de modificaciones -->
              <b-table
                  id="b-table"
                  :items="itemsHistoryAbs"
                  :fields="fieldsHistoryAbs"
                  head-variant="light"
                  class=""
                  table-variant="se">

                <template #cell(details)="row">
                  <b-icon @click="row.toggleDetails"
                          :icon="row.detailsShowing ? 'chevron-up':'chevron-down'"
                          font-scale="1.5"
                          class="principal-color-v2 pointer">
                  </b-icon>
                </template>

                <template #row-details="row">
                  <datatable
                      id="sub-b-table"
                      :columns="[
                          {
                              field:'columna',
                              label: 'Sección',
                              sortable: false
                          },
                          {
                              field:'valor_anterior',
                              label: 'Estado anterior',
                              sortable: false
                          },
                          {
                              field:'nuevo_valor',
                              label: 'Estado modificado',
                              align: 'center',
                              sortable: false
                          }
                      ]"
                      :data="row.item.details"
                      class="col-12" >
                  </datatable>
                </template>
              </b-table>
              <b-col class="col-12 pagination-v2 my-5 d-flex justify-content-center">
                <Pagination :data="historyAbs"
                            :limit="10"
                            @pagination-change-page="getHistoryPagination" />
              </b-col>

              <b-col cols="12" class="d-flex justify-content-center">
                <button
                    @click="$bvModal.hide('modal-history-abs')"
                    class="button-v2 primary new-responsive">
                  Entendido
                </button>
              </b-col>

              <!-- end -->
            </b-col>
          </b-row>
        </b-container>
        <!-- <h3 class="font-weight-bold mb-4" style="background-color: #00E455">
            <img class="centerImg1 mr-3" src="@/assets/images/icons/blue-eye.svg" width="33px">Historial de modificaciones realizadas
        </h3> -->

        <!-- <div class="col-12 d-flex flex-column align-items-center">
            <div class="col-12">
                <b-table
                :items="itemsHistoryAbs"
                :fields="fieldsHistoryAbs">

                    <template #cell(Detalles)="row" @click="row.toggleDetails">
                        <template @click="row.toggleDetails">
                            <a v-if="row.item.details[0]" size="sm" @click="row.toggleDetails" class="mr-2" style="cursor: pointer;">
                            {{ row.detailsShowing ? 'Ocultar' : 'Mostar'}} Detalles <img class="centerImg1" src="@/assets/images/icons/blue-eye.svg" width="15px">
                            </a>
                            <p v-else>---</p>
                        </template>
                    </template>

                    <template #row-details="row">
                        <b-table :items="row.item.details" style="background-color:#f3f3f3;"></b-table>
                    </template>
                </b-table>
                <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
                    <Pagination :data="historyAbs" :limit="10" @pagination-change-page="getHistory"></Pagination>
                </div>
            </div>
            <button class="mt-5 mb-5 col-4 btn btn-success" @click="$bvModal.hide('modal-history-abs')">Entendido</button>
        </div> -->
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import Pagination from "laravel-vue-pagination";
import PieChart from "@/components/charts/PieChart.js";
import Multiselect from 'vue-multiselect'
export default {
  components: {
    PieChart,
    Pagination,
    Multiselect
  },
  props: {
    dataUser:{},
    userAbs:{},
    nameStadistcs:{},
    totalAbsenteeism:{},
    time:{},
    filterButton:Boolean,
    HistoryButtonAbs:Boolean,
    stadistics: String,
    pagination:Boolean

  },
  data() {
    return {

      //   Variables del filtro
      filterFrom:'',
      filterTo:'',
      optionsDiagFilter:[{value:null,text:'Diagnóstico'}],
      optionsAbsFilter:[],
      selectedDiagFilter:{value:null,text:'Diagnóstico'},
      selectedAbsFilter:[],
      popoverShow:false,

      //   Variables del Historial
      fieldsHistoryAbs:[],
      itemsHistoryAbs:[],
      chartLabels: {},
      chartData: {},
      buttonCancellConfirm:'',
      buttonSaveConfirm:'',
      textConfirm:'',
      selectedCertificate:null,
      selectedIssuer:null,
      groupDiagnostic:'',
      typeAbsence:'',
      diagnosticSelected:'',
      riskClassificationSelected:'',
      carlos: "hola carlos andres",
      datatableEmployeeModal: {
        columns:[],
        rows:[]
      },
      datatableAbs: {
        total: 18,
        perPage: 20,
        columns: [],
        rows: [],
      },
      tableConfirm1: {
        columns:[
          {
            label: "Tipo",
            field: "type",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Diagnostico CIE XI",
            field: "cie",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Emisor",
            field: "issuer",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
        ],
        rows:[]
      },
      tableConfirm2: {
        columns:[
          {
            label: "Clasificación del origen del peligro / Riesgo que generó el ausentismo",
            field: "clasification",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          }
        ],
        rows:[]
      },
      tableConfirm3: {
        columns:[
          {
            label: "Fecha de Inicio",
            field: "dateStart",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Fecha final",
            field: "dateEnds",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Días perdidos",
            field: "days",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Horas de ausencia",
            field: "hours",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
        ],
        rows:[]
      },
      tableConfirm4: {
        columns:[{
          label: "Descripción",
          field: "description",
          align: "center",
          headerClass: "theading",
          interpolate: true,
          sortable: false
        }],
        rows:[]
      },
      tableConfirm5: {
        columns:[
          {
            label: "Medico emisor",
            field: "medico",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "IPS emisor",
            field: "ips",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
          {
            label: "Origen incapacidad",
            field: "origen",
            align: "center",
            headerClass: "theading",
            interpolate: true,
            sortable: false
          },
        ],
        rows:[]
      },
      tableDescription: '',
      tabIndex:1,
      optionsIssuer:[{value:null,text:'Seleccione el emisor de la ausencia'}],
      optionsCertificate:[{value:null,text:'Estado del certificado de la Incapacidad'}],
      optionsOrigen:[{value:null,text:'Seleccione el origen de la Incapacidad'}],
      reportFrom: '',
      reportTo: '',
      dateAbs:'',
      daysAbs:'',
      hoursAbs:'',
      descriptionAbs:'',
      editAbsForm:false,
      showTitles:false,
      inabilityOrigin: '',
      medicalDisability: '',
      incapacityIps: '',
      riskDanger: null,  //classification_of_risk_or_danger
      diagnosticGroup: null, //diagnostic_group,
      emitterAbsence: null,  //emitter_of_absence
      dataErrors: [],
      showNextStep: true,
      file:'',
      processingSaveAbsenteeism: false
      ,errosSaveAbsenteeism: [],
      dataErrorsRegister: []
      ,stadisticsColors: []
    }
  },
  computed: {
    get_difference_register_absenteeism () {
      return (this.get_date_difference(this.reportFrom, this.reportTo) + 1)
    },
    get_difference_register_absenteeism_hours () {
      return (this.get_difference_register_absenteeism * 8)
    },
    ...mapState("modOhAnalyst", [
      "loading",
      "loading2",
      "error",
      "message",
      "employeeInfo",
      "typesAbsenteeism",
      "groupsDiagnostics",
      "diagnostics",
      "riskClassification",
      "listsAbsenteeism",
      "absenteeism",
      "historyAbs",
      "filters",
      "detailAbs",
    ]),
    ...mapState("modCore", ["user"])
  },
  beforeMount() {
    this.loadRows()
  },
  watch: {
    reportTo() {
      if (this.reportFrom != null) {
        this.daysAbs = this.get_difference_register_absenteeism
        this.hoursAbs = this.get_difference_register_absenteeism_hours
      }
    }
  },
  methods: {
    ...mapActions("modOhAnalyst", [
      'actGetEmployeeInfo',
      'actGetTypesAbsenteeism',
      'actGetGroupsDiagnostics',
      'actGetDiagnostics',
      'actGetRiskClassification',
      'actGetListsAbsenteeism',
      'actSaveAbsenteeism',
      'actGetAbsenteeism',
      'actGetHistoryOfAbsenteeism',
      'getHistoryAbs',
      'actFilterEmployeeDetail',
      'actGetDetailAbsenteeism'
    ]),
    setFilter(page = 1){
      let diagnosticsIds = []
      if(this.selectedAbsFilter !== []){
        this.selectedAbsFilter.forEach(x => {
          diagnosticsIds.push(x.item.id)
        })
      }
      let data = {
        page:page,
        id: this.dataUser.id,
        start_date: this.filterFrom,
        end_date : this.filterTo,
        types_absenteeism : (diagnosticsIds[0]? diagnosticsIds : null),
        diagnosis_cie_id : (this.selectedDiagFilter !== null? this.selectedDiagFilter.id : null)
      }
      this.actGetDetailAbsenteeism(data).then(() => {
        this.userAbs= this.detailAbs.absenteeism
        this.totalAbsenteeism= this.detailAbs.summary
        this.time= this.detailAbs.time
      })
    },
    filter(){
      this.optionsDiagFilter= [{value:null,text:'Diagnóstico'}],
          this.optionsAbsFilter= [],
          this.actFilterEmployeeDetail(this.dataUser.id).then(() => {
            this.filters.types_absenteeism.forEach(x => {
              this.optionsAbsFilter.push({
                item: x,
                name: x.name
              })
            })
            this.filters.diagnosis.forEach(x => {
              this.optionsDiagFilter.push({
                value:x,text:x.name
              })
            })
          })
    },
    onFileChange(e){
      this.file = e.target.files[0];
    },
    addTag (newTag) {
      const tag = {
        item: newTag + Math.floor((Math.random() * 10000000)),
        name: newTag,
      }
      this.optionsAbsFilter.push(tag)
      this.selectedAbsFilter.push(tag)
    },
    cleanDataFilter(){
      this.popoverShow = false
      this.filterFrom= ''
      this.filterTo= ''
      this.selectDiagFilter= {}
      this.selectedAbsFilter= []
    },
    async getHistoryAbs(){
      this.itemsHistoryAbs = []
      this.$root.$emit('bv::show::modal','modal-history-abs')
      await this.actGetHistoryOfAbsenteeism({
        id: this.dataUser.id
      }).then(()=> {
        this.mapHistoryAbs()
      })
      this.forgetTableStyleById()

    },
    async getHistoryPagination(page = 1) {
      await this.actGetHistoryOfAbsenteeism({
        id: this.dataUser.id,
        page,
      }).then(()=> {
        this.mapHistoryAbs()
      })
      this.forgetTableStyleById()
    },
    /**
     * Mapeo del historial de ABS
     **/
    mapHistoryAbs () {
      this.fieldsHistoryAbs = [
        {
          key:'employeeNameAndProfile',
          label: 'Nombre/Perfil'
        },
        {
          key:'type',
          label: 'Tipo'
        },
        {
          key:'characterization',
          label: 'Caracterización'
        },
        {
          key:'dataTime',
          label: 'Fecha y Hora'
        },
        {
          key:'details',
          label: ''
        }
      ]
      this.itemsHistoryAbs = []
      this.historyAbs.data.forEach(x => {
        this.itemsHistoryAbs.push({
           employeeNameAndProfile: `${x.employee_name}/${x.employee_profile}`,
           type: (x.modification_type === 'created') ? 'Nuevo' : 'Edición',
           characterization: 'Sin informacion',
           dataTime: x.date,
           details: x.modification_type === 'created' ?
               this.transformNewValuesOfHistory(x.new_values)
               : this.transformOldValuesOfHistory(x.old_values, x.new_values)
        })
      })
    }
    ,transformOldValuesOfHistory (oldValues, newValue) {
      return this.transformResponse(this.transformGetColumn(oldValues)
          ,this.transformGetValue(oldValues)
          ,this.transformGetValue(newValue)
      )
    }
    ,transformNewValuesOfHistory (values) {
      return this.transformResponse(this.transformGetColumn(values)
          ,this.transformGetValue(values)
      )
    }
    ,transformResponse (keys, oldValues, newValues = [] )
    {
      return keys.map((key, index) => {
        return ({
          columna: key
          ,valor_anterior: oldValues[index]
          ,nuevo_valor: newValues[index]??null
        })
      })
    }
    ,transformGetColumn (columns)
    {
      return Object.keys(columns).map(value => value)
    }
    ,transformGetValue (values)
    {
      return Object.values(values).map(value => value)
    }
    ,cleanData(){
      this.groupDiagnostic = ''
      this.typeAbsence = ''
      this.diagnosticSelected = ''
      this.riskClassificationSelected = ''
    },
    loadRows(){
      this.datatableAbs.columns = [
        /*{
            label: "ID",
            field: "id",
            align: "center",
            headerClass: "theading",
        },*/
        {
          label: "Fecha Inicial",
          field: "startDate",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "Fecha final",
          field: "endDate",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "Días perdidos",
          field: "days",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "Tipo",
          field: "type",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "Origen",
          field: "origin",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "Emisor",
          field: "emisor",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "DX",
          field: "dx",
          align: "center",
          headerClass: "theading",
          sortable: false
        },
        {
          label: "Certificado",
          field: "certificate",
          align: "center",
          headerClass: "theading",
          interpolate: true,
          sortable: false
        },
        {
          label: "",
          field: "view",
          align: "center",
          headerClass: "theading",
          interpolate: true,
          sortable: false
        },

      ]
      this.datatableAbs.rows = []
      console.log('this.userAbs',this.userAbs)
      this.userAbs.data.forEach(x => {
        let status = null
        switch (x.status){
          case 'Pendiente' :
            status = {
              color:'#E66401',
              backgroundColor: '#FFFBE6',
              icon: 'orange-clock.svg',
              text: 'Pendiente'
            }
            break
          case 'Recibido':
            status = {
              color:'#00761A',
              backgroundColor: '#F6FFED',
              icon: 'check.svg',
              text: 'Recibido'
            }
            break
        }
        this.datatableAbs.rows.push({
          id:x.id,
          startDate:x.start_date,
          endDate:x.end_date,
          days:x.days,
          type:x.type_absence,
          emisor:x.transmitter,
          dx:x.diagnosis,
          origin: x.origin,
          view: `<span style="cursor: pointer;"><img class="centerImg1 mr-1" src="${require('@/assets/images/icons/eye-line.png')}" width="20px"/> </span>`,
          certificate: status ? `<span class="d-inline-flex" style="background-color:${status?.backgroundColor}; color:${status?.color}"><img class="centerImg1 mr-1"  src="${require('@/assets/images/icons/' + status?.icon)}" width="20px">${status?.text}</span>` : '',
        })
      })
      this.chartLabels= [
        this.totalAbsenteeism.name,
        'Otros'
      ]
      this.stadisticsColors = [
        this.COLORS.PRIMARY,
        this.COLORS.OUTLINE_PRIMARY
      ]
      this.chartData= [
        this.totalAbsenteeism.most_requested,
        (this.totalAbsenteeism.total - this.totalAbsenteeism.most_requested)
      ]

    },
    refreshData(){
      this.$emit('change:reload-data')
    },
    getHours(){
      if (this.daysAbs < 1 || this.hoursAbs < 8) { return }
      this.hoursAbs = this.daysAbs * 8
    },
    newAbs(){
      this.editAbsForm = false
      this.$root.$emit('bv::show::modal','modal-new-abs')
      this.datatableEmployeeModal.columns = [
        {
          label: "Nombres y apellidos",
          field: "name",
          align: "center",
          headerClass: "theading",
        },
        {
          label: "Área",
          field: "area",
          align: "center",
          headerClass: "theading",
        },
        {
          label: "Cargo",
          field: "charge",
          align: "center",
          headerClass: "theading",
        },
        {
          label: "Fecha de ingreso",
          field: "startDate",
          align: "center",
          headerClass: "theading",
        },

      ]
      this.datatableEmployeeModal.rows=[]
      this.datatableEmployeeModal.rows.push({
        name:this.dataUser.employee,
        area:this.dataUser.area,
        charge:this.dataUser.charge,
        startDate:this.dataUser.created_at,
      })
      this.optionsIssuer = [{value:null,text:'Seleccione el emisor de la ausencia'}]
      this.optionsCertificate = [{value:null,text:'Estado del certificado de la Incapacidad'}]
      this.optionsOrigen = [{value:null,text:'Seleccione el origen de la Incapacidad'}]
      this.cleanData()
      this.actGetListsAbsenteeism().then(() => {
        this.listsAbsenteeism.transmitter.forEach(x => {
          this.optionsIssuer.push({
            value:x,
            text:x.name
          })
        });
        this.listsAbsenteeism.status_certificate.forEach(x => {
          this.optionsCertificate.push({
            value:x,
            text:x.name
          })
        });
        this.listsAbsenteeism.origin.forEach(x => {
          this.optionsOrigen.push({
            value:x,
            text:x.name
          })
        })
      })
      this.actGetTypesAbsenteeism()
    },
    filterTypesAbs(search,loading){
      loading(true)
      this.actGetTypesAbsenteeism(search).then(()=> loading(false))
      this.disableFirstStep();
    },
    filterGroupsDiagnostics(search,loading){
      loading(true)
      this.actGetGroupsDiagnostics(search).then(()=> loading(false))
      this.disableFirstStep();
    },
    filterRiskClassification(search,loading){
      loading(true)
      this.actGetRiskClassification(search).then(()=> loading(false))
      this.disableFirstStep();
    },
    filterDiagnosticsByGroup(){
      let search = {
        group:this.groupDiagnostic.id
      }
      this.actGetDiagnostics(search)
      this.disableFirstStep();
    },
    filterDiagnostics(name,loading){
      loading(true)
      let search = {
        search:name
      }
      this.actGetDiagnostics(search).then(() => { loading(false) })
      this.disableFirstStep();
    },
    checkTypeOfAbs(){
      if(!this.absenteeism.options){
        this.diagnosticSelected = ''
        this.riskClassificationSelected = ''
      }
      this.showTitles = true
      this.riskDanger = this.typeAbsence.options.classification_of_risk_or_danger; // true or false
      this.diagnosticGroup = this.typeAbsence.options.diagnostic_group; // true or false
      this.emitterAbsence = this.typeAbsence.options.emitter_of_absence; // true or false
    },
    validateNewAbs(){
      this.dataErrorsRegister = [];

      console.log(this.descriptionAbs, this.selectedCertificate, this.inabilityOrigin, this.medicalDisability, this.incapacityIps);
      console.log(this.dataErrorsRegister)

      // if (this.descriptionAbs == '') {
      //   this.dataErrorsRegister.push("Debe digitar un riesgo")
      // }
      if (this.selectedCertificate == null) {
        this.dataErrorsRegister.push("Debe seleccionar un Estado del certificado del ausentismo")
      }
      if (this.selectedCertificate != null && this.selectedCertificate.id == 'received') {
        this.dataErrorsRegister.push("Debe adjuntar certificado del ausentismo")
      }
      if (this.file !== '') {
        this.confirmNewAbs()
      }
      // if (this.inabilityOrigin == '') {
      //   this.dataErrorsRegister.push("Debe digitar un origen de la incapacidad")
      // }
      // if (this.medicalDisability == '') {
      //   this.dataErrorsRegister.push("Debe digitar un Médico que emite la incapacidad")
      // }
      // if (this.incapacityIps == '') {
      //   this.dataErrorsRegister.push("Debe digitar un estado del certificado del ausentismo")
      // }
      if (!this.dataErrorsRegister.length) {
        this.confirmNewAbs()
      }
    },
    confirmNewAbs(){

      this.textConfirm = this.editAbsForm ?
          '¿Estás seguro de modificar este ausentismo de'
          : '¿Estás seguro de agregar este ausentismo a'

      this.tableConfirm1.rows = []
      this.tableConfirm2.rows = []
      this.tableConfirm3.rows = []
      this.tableConfirm4.rows = []
      this.tableConfirm5.rows = []
      console.log("HOLA TABLA",this.selectedIssuer, this.selectedIssuer.name)
      this.tableConfirm1.rows.push({
        type:(this.typeAbsence === '' ? this.no_apply():this.typeAbsence.name),
        cie:(this.diagnosticSelected === '' ? this.no_apply():this.diagnosticSelected.name),
        issuer:this.optionsIssuer != null && this.selectedIssuer.name ? this.selectedIssuer.name : ''
      })
      this.tableConfirm2.rows.push({
        clasification:(this.riskClassificationSelected === '' ? this.no_apply():this.riskClassificationSelected.name)
      })

      this.tableConfirm3.rows.push({
        dateStart:this.reportFrom,
        dateEnds:this.reportTo,
        days:this.daysAbs,
        hours:this.hoursAbs,
        issuer:this.selectedIssuer.name
      })
      this.tableConfirm4.rows.push({
        description:this.descriptionAbs
      })
      this.tableConfirm5.rows.push({
        medico:this.medicalDisability,
        ips:this.incapacityIps,
        origen:this.inabilityOrigin.name,
      })
     this.$root.$emit('bv::show::modal','modal-confirm')
    }
    ,async saveNewAbs() {
      this.processingSaveAbsenteeism = true
      let form = new FormData()
      form.append('core_employee_id', this.dataUser.id)
      form.append('days', this.daysAbs)
      form.append('description', this.descriptionAbs)
      form.append('end_date', this.reportTo)
      form.append('hours', this.hoursAbs)
      form.append('start_date', this.reportFrom)
      form.append('status', (this.selectedCertificate !== null ? this.selectedCertificate.id : 'not-apply'))
      form.append('transmitter', this.selectedIssuer.id)
      form.append('type_absence_id', this.typeAbsence.id)
      form.append('origin_of_disability', this.inabilityOrigin.id)
      form.append('physician_who_issues_disability', this.medicalDisability)
      form.append('ips_issuing_disability', this.incapacityIps)

      if (
          this.riskClassificationSelected !== ''
      ) {
        form.append('risk_classification_id', this.riskClassificationSelected.id)
      }

      if (
          this.diagnosticSelected !== ''
      ) {
        form.append('diagnosis_cie_id', this.diagnosticSelected.id)
      }

      if (
          this.file !== ''
      )
      {
        form.append('file', this.file )
      }

      await this.actSaveAbsenteeism(form)
          .then(() => {
            this.errosSaveAbsenteeism = []
            this.$root.$emit('bv::hide::modal','modal-confirm')
            this.$root.$emit('bv::show::modal','modal-success')
          })
          .catch(({ response: { data : { message }} }) => {
            this.errosSaveAbsenteeism = message
          }).finally(() => {
            this.processingSaveAbsenteeism = false
          })

      // this.actSaveAbsenteeism(data).then(() => {
      //
      //
      //   if(this.error.message){
      //     this.$root.$emit('bv::hide::modal','modal-confirm')
      //     this.$root.$emit('bv::show::modal','modal-fail')
      //
      //   }else{
      //     this.$root.$emit('bv::hide::modal','modal-confirm')
      //     this.$root.$emit('bv::show::modal','modal-success')
      //   }
      // })
    },
    viewAbs(id){
      this.$root.$emit('bv::show::modal','modal-edit-abs')
      this.editAbsForm = false
      this.actGetAbsenteeism(id).then(() => {
        this.datatableEmployeeModal.columns = [
          {
            label: "Nombres y apellidos",
            field: "name",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
          {
            label: "Área",
            field: "area",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
          {
            label: "Cargo",
            field: "charge",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
          {
            label: "Fecha de ingreso",
            field: "startDate",
            align: "center",
            headerClass: "theading",
            sortable: false
          },
        ]
        this.datatableEmployeeModal.rows=[]
        this.datatableEmployeeModal.rows.push({
          name:this.dataUser.employee,
          area:this.dataUser.area,
          charge:this.dataUser.charge,
          startDate:this.dataUser.created_at ?? 'Aún no tiene registro',
        })
        this.tableConfirm1.rows = []
        this.tableConfirm2.rows = []
        this.tableConfirm3.rows = []
        this.tableConfirm4.rows = []
        this.tableConfirm5.rows = []

        // const values = {
        //   null: this.no_apply,
        //   not_apply: this.no_apply
        // }
        this.tableConfirm1.rows.push({
          type:this.absenteeism.type_absenteeism_name,
          cie:(this.absenteeism.diagnostic_name == null? this.no_apply() :this.absenteeism.diagnostic_name),
          issuer: this.absenteeism.transmitter,
        })
        this.tableConfirm2.rows.push({
          clasification:(this.absenteeism.risk_classification_name == null? this.no_apply() :this.absenteeism.risk_classification_name)
        })

        this.tableDescription = this.absenteeism.description

        this.tableConfirm4.rows.push({
          description:this.absenteeism.description
        })

        this.tableConfirm5.rows.push({
          medico:this.absenteeism.doctor_name,
          ips:this.absenteeism.ips,
          origen:this.absenteeism.origin,
        })


        this.tableConfirm3.rows.push({
          dateStart:this.absenteeism.start_date,
          dateEnds:this.absenteeism.end_date,
          days:this.absenteeism.days,
          hours:this.absenteeism.hours
        })
        this.selectedCertificate = this.absenteeism.status

      })
    },
    no_apply () {
      return 'No Aplica'
    },
    editAbs(){
      this.editAbsForm = true
      this.actGetTypesAbsenteeism(this.absenteeism.type_absenteeism_name).then(() => {
        this.typeAbsence = this.typesAbsenteeism[0]
        if(this.typeAbsence.options){
          this.actGetRiskClassification(this.absenteeism.risk_classification_name).then(() => {
            this.riskClassificationSelected = this.riskClassification[0]
          })
          let search = {
            search:this.absenteeism.diagnostic_name
          }
          this.actGetDiagnostics(search).then(() => {
            this.diagnosticSelected = this.diagnostics[0]
          })
        }
      })
      this.actGetListsAbsenteeism().then(() => {
        this.optionsIssuer = []
        this.listsAbsenteeism.transmitter.forEach(x => {
          this.optionsIssuer.push({
            value:x,
            text:x.name
          })
        });
        for (let index = 0; index < this.optionsIssuer.length; index++) {
          if (this.selectedIssuer === null) { this.selectedIssuer = this.optionsIssuer[0].value }
          if(this.optionsIssuer[index].value.id === this.absenteeism.transmitter ){
            this.selectedIssuer = this.optionsIssuer[index].value
          }
        }
        this.optionsCertificate = []
        this.listsAbsenteeism.status_certificate.forEach(x => {
          this.optionsCertificate.push({
            value:x,
            text:x.name
          })
        })
        this.optionsCertificate.forEach(x => {
          if(x.value.id == this.absenteeism.status ){
            this.selectedCertificate = x.value
          }
        })
      })
      this.reportFrom = this.absenteeism.start_date
      this.reportTo = this.absenteeism.end_date
      this.daysAbs = this.absenteeism.days
      this.hoursAbs = this.absenteeism.hours
      this.descriptionAbs = this.absenteeism.description
    },
    SaveEditAbs() {
      let data = {
        "start_date": this.reportFrom,
        "end_date": this.reportTo,
        "days": this.daysAbs,
        "hours": this.hoursAbs,
        "core_employee_id": this.dataUser.id,
        "type_absence_id": this.typeAbsence.id,
        "diagnosis_cie_id": (this.diagnosticSelected == '' ? null : this.diagnosticSelected.id),
        "risk_classification_id": (this.riskClassificationSelected == '' ? null : this.riskClassificationSelected.id),
        "transmitter": this.selectedIssuer.id,
        "description": this.descriptionAbs,
        "status": this.selectedCertificate.id,
        "id": this.absenteeism.id
      }
      this.actActAbsenteeism(data).then(() => {
        // if(this.error.message){
        //   this.$root.$emit('bv::hide::modal','modal-confirm')
        //   this.$root.$emit('bv::show::modal','modal-fail')
        // }else{
        //   this.$root.$emit('bv::hide::modal','modal-confirm')
        //   this.$root.$emit('bv::show::modal','modal-success')
        // }
      })
    },
    disableFirstStep() {
       this.dataErrors = [];
      if (this.typeAbsence != null && this.typeAbsence.options) {
        if (this.riskDanger && this.riskClassificationSelected == '') {
          this.dataErrors.push("Debe seleccionar un riesgo")
        }
        if (this.diagnosticGroup && this.groupDiagnostic == '') {
          this.dataErrors.push("Debe seleccionar un grupo diagnostico")
        } else if (this.diagnosticSelected && this.diagnosticSelected == '') {
          this.dataErrors.push("Debe seleccionar un Diagnóstico")
        }
        if (this.emitterAbsence && this.selectedIssuer == '' || this.selectedIssuer == null) {
          this.dataErrors.push("Debe seleccionar un Emisor")
        }
        if (!this.dataErrors.length) {
          this.showNextStep = false;
        }else{
          this.showNextStep = true;
        }
      }else{
        this.showNextStep = true;
      }
      return true;
    },
    filterHours(day){
      // if(
      //   this.reportTo == '' || this.reportFrom == '' || this.daysAbs == '' || this.hoursAbs == ''
      //   || this.daysAbs > this.get_difference_register_absenteeism
      //   || this.daysAbs < 1
      //   || this.hoursAbs > this.get_difference_register_absenteeism_hours
      //   || this.hoursAbs < 1
      // ){
      //   this.dataErrors.push("debe ingresar un maximo de "+ this.daysAbs * day);
      // }
      // reportTo == '' || reportFrom == '' || daysAbs == '' || hoursAbs == ''
      //   || daysAbs > get_difference_register_absenteeism
      //   || daysAbs < 1
      //   || hoursAbs > get_difference_register_absenteeism_hours
      //   || hoursAbs < 1 ?
      console.log(day, this.daysAbs,this.hoursAbs)
      // if(this.hoursAbs > this.daysAbs* day){
      //   this.dataErrors.push("debe ingresar un maximo de "+ this.daysAbs * day);
      // }
    },
    clickRow(id, eid) {
      this.$router.push({ name: "editAbsenteeism", params: { id: id, eid: eid } });
    },
  }
}
</script>

<style lang="scss">

#popover {
  font-family: 'Ubuntu';
  font-style: normal;
  font-size: 16px;
  border: 0;
  height: auto;
  word-wrap: break-word;
  p {
    font-size: 12px;
  }
}
.b-popover {
  border-radius: 10px;
  border: 0;
  font-family: 'Ubuntu';
  font-style: normal;
  font-size: 16px;

  p.separate{
    color: #0075FF;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
  }
  .popover-header{
    border-radius: 10px;
  }
  .popover-body{
    max-width: 400px;
    .b-form-datepicker{
      padding: 3px;
      border: #d8d8d8 1px solid !important;
    }
    select, input{
      padding: 5px;
      height: 40px;
      border-radius: 8px;
    }
  }
}

.btn .b-icon.bi, .nav-link .b-icon.bi, .dropdown-toggle .b-icon.bi, .dropdown-item .b-icon.bi, .input-group-text .b-icon.bi {
  color: var(--main-primary-color);
  font-size: 130%;
}

.popover-body {
  width: 348px;
  height: auto;
  word-wrap: break-word;

  /* Neutral / White */
  background: #FFFFFF;

  /* Neutral / Gray blue light */
  border: 1px solid #F5F5F5;

  /* Mid */
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.multiselect__option--highlight {
  background: var(--main-primary-color);
}

.multiselect__option--highlight::after {
  background: var(--main-primary-color);
}

.multiselect__tag {
  background: var(--main-primary-color);
}

.multiselect__tag-icon::after {
  background: var(--main-primary-color);
}

.multiselect__tag-icon:hover {
  background: var(--main-primary-color);
}



#absenteeism{

  .cardEstadistics {
    border: 1.0263px solid #F5F5F5;
    border-radius: 25px;
    p{
      font-size: 12px;
    }
  }
  .custom-select{
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .btn-create{
    padding: 12px;
    border: none;
    color: white;
    display: flex;
    align-items: center;
    transition: 0.5s;
    span {
      font-size: 30px;
      line-height: 0;
      margin: 0 5px;
      font-weight: 500;
    }
  }
  .btn-create:hover{
    background-color: #7A7CFF;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  }
  /*.status{
      padding: 5px 15px;
      border-radius: 20px;
  }*/
  .buttonColapse{
    padding: 6px 12px;
    gap: 4px;
    border: 2px solid #7A7CFF;
    color:#7A7CFF;
    font-size: 14px;
    border-radius: 100px;
  }
  .buttonColapse2{
    padding: 6px 12px;
    gap: 4px;
    color:#FFFFFF;
    font-size: 16px;
    background: #7A7CFF;
    border-radius: 4px;
  }
  .btn-outline-success:hover, .btn-success{
    color: white;
    background-color: #7A7CFF;
    border-color: #7A7CFF;
  }
  .btn-success:hover{
    background-color: #7A7CFF;
  }
  .regular{
    background-color: #FFFFFF;
    padding: 6px 12px;
    gap: 4px;
    border: none;
    color: #7A7CFF;
    border: 1px solid #5D5FEF;
    border-radius: 4px;

  }
  .table-views{
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    border:#DDDDDD solid 1px;
    padding: 0;
    margin: 30px 5px;
    font-size: 14px;
    .theading{
      width: 25%;
    }
  }
  .tableAbs{
    font-size: 14px;
    tbody tr{
      cursor: pointer;
    }
    tbody tr:hover{
      background-color: #F5F5F5;
    }
  }
  .t-head{
    background-color: #F5F5F5;
    padding: 5px 15px;
    text-align: left;
  }
  input{
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .theading{
    padding: 10px 10px;
    text-align: left;
  }
  tbody tr td {
    padding: 10px 2px;
  }
}
.history-absenteeism {
  label {
    color: #78909C;
  }
  .title-form-history {
    font: normal normal 700 16px/1 "Ubuntu";
    color: #004BD1;
  }
  .btn-save {
    width: max-content;
    display: block;
    padding: 12px;
    text-transform: uppercase;
  }
  .box-btn {
    margin-top: 50px;
  }
}

.modal-abs, #modal-edit-abs, #modal-history-abs {
  #loader2 {
    margin: 20px auto;
    z-index: 1;
    width: 100px;
    height: 100px;
    border: 15px solid #f3f3f3;
    border-radius: 50%;
    border-top: 15px solid #8f8f8f;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
}
.modal-content .modal-abs{
  font-family: Open Sans;
  .status{
    padding: 5px 15px;
    border-radius: 20px;
  }
  h1{
    letter-spacing: 0em;
    text-align: left;
    font: normal normal 500 21px/24px "Ubuntu";
    width: 100%;
    text-transform: initial;
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 20px;
    &:before {
      content: '';
      background: url("../../assets/images/icons/permisos-block.svg") center/contain no-repeat;
      display: block;
      position: relative;
      width: 20px;
      height: 20px;
    }
  }
  select.custom-select, input{
    padding: 8px;
    font-size: 16px;
    height: 44px;
    border-radius: 8px;
    margin: 0;
  }
  .b-form-datepicker{
    padding: 5px 5px;
    font-size: 15px;
    border-radius: 10px;
    border: #AAAAAA 1px solid;
  }
  .charge{
    border: 1px dashed #DDDDDD;
    border-radius: 8px;
  }
  .modal-header{
    border: none;
  }
  .input-vp2, button{
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;

  }
  textarea:focus,input:focus{
    outline: none;
  }
  .btn-outline-success{
    border-radius: 20px;
    color: #7A7CFF;
    border-color: #7A7CFF;
  }
  .btn-outline-success:hover, .btn-success{
    color: white;
    background-color: #7A7CFF;
    border-color: #7A7CFF;
  }
  .btn-success:hover{
    background-color: #27a391;
  }
  .regular{
    background-color: white;
    border: none;
    color: #269887;
  }
  .delete{
    background-color: white;
    border: none;
    color: #DA1414;
  }
  h3{
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    text-align: center;
  }
  .detail{
    select.custom-select, input, textarea{
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
      border: #AAAAAA 1px solid;
      width: 100%;
    }
    textarea{
      height: 150px;
    }
  }
  .nav-tabs{
    border: 1px solid #5D5FEF !important;
    width: max-content;
    margin: 0 auto;
    padding: 2px;
    border-radius: 50px;
    a{
      color: #B0BEC5 !important;
      padding: 5px 15px;
      margin: 0;
    }
    a.active {
      background: #5D5FEF;
      border-radius: 50px;
      border: 0;
      color: #ffffff !important;
      border-bottom: solid 3px;
      border-color: #7A7CFF;
    }
    a:hover {
      text-decoration: none;
      border: none;
    }
  }
  .table-views{
    height: fit-content;
    border-radius: 8px;
    padding: 0;
    .t-head{
      background-color: #F5F5F5;
      padding: 5px 15px;
      text-align: left;
      font-size: 15px;
    }
    thead tr{
      background-color: #EEF2FA;
      border-radius: 10px;
      text-align: left !important;
    }
    .theading{
      padding: 15px 10px;
    }
    th.theading span{
      font: normal normal normal 15px/1 "Ubuntu";
      color: #546E7A;
    }
    tbody tr {
      border-radius: 10px;
    }
    tbody tr td{
      padding: 15px 10px;
      font-size: 14px;
    }
    .buttonColapse, .buttonColapse:hover,.buttonColapse:active{
      background-color: transparent;
      border:none;
      box-shadow:none;
    }
  }
  .formulario{
    h3{
      font-size: 16px;
      color: #1C3A4E;
      font-weight: 600;
    }
    .vc-container{
      font-family: Poppins;
      box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
      border: none;
      .vc-grid-cell{
        margin: 5px;
      }
    }
  }
  .vs__selected {
    word-break: break-word;
    margin: 0 !important;
  }
  .vs__dropdown-toggle {
    border: 1px solid #B0BEC5;
    border-radius: 8px;
    padding: 0;
  }
  .vs__dropdown-toggle input {
    color: #78909C;
    font: normal normal 300 16px/1 "Ubuntu";
    &::placeholder {
      color: #78909C;
    }
  }
  .vs__actions .vs__clear {
    display: none;
  }
  .vs__selected-options {
     padding: 8px;
    font-size: 16px;
    min-height: 44px;
    border-radius: 8px;
    margin: 0;
    input  {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
  .detail .text-input {
    position: absolute;
    left: 16px;
    top: -6px;
    font: normal normal 300 12px/1 "Ubuntu";
    color: #78909C;
    background: #ffffff;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 4px;
    padding: 0px 4px;
    z-index: 9;
  }
}
#modal-edit-abs .modal-content .modal-abs{
  input, .b-form-btn-label-control, .custom-select, .vs__dropdown-toggle{
    border: none;
  }
}
</style>